import React from 'react';
import { ChevronLeft } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './timeslot-title.style';

export type TimeslotTitleProps = {
  title: string;
  icon?: React.ReactNode;
  color?: string;
  showChevron?: boolean;
};

export const TimeslotTitle: React.FC<TimeslotTitleProps> = ({
  title,
  icon,
  color,
  showChevron,
}) => {
  if (!icon) {
    return <Styled.Title>{title}</Styled.Title>;
  }

  return (
    <Styled.Container>
      <Styled.IconContainer $color={color}>{icon}</Styled.IconContainer>
      <Styled.Content>
        <Styled.Title>{title}</Styled.Title>
        {showChevron && (
          <Styled.ChevronContainer>
            <Icon icon={ChevronLeft} />
          </Styled.ChevronContainer>
        )}
      </Styled.Content>
    </Styled.Container>
  );
};
